import React from 'react';
import logoImg from '../../images/svg/bglobe-logo-white.svg';
import { SUBDOMAIN } from '../../constants/constants-urls';
/**
 * Site header.
 * @returns {React.component} The Header to render.
 */
export default function Header() {
  const environment = process.env.REACT_APP_ENVIRONMENT;
  const homepage = `https://${SUBDOMAIN[environment]}.bostonglobe.com`;
  return (
    <header className="site-header">
      <a href={homepage}>
        <img src={logoImg} alt="The Boston Globe" />
      </a>
    </header>
  );
}



// WEBPACK FOOTER //
// ./src/containers/Header/Header.js